import { createContext } from 'react';

//@ts-ignore
const ADULT_COVER_URL = global.Ridi?.globals?.staticUrl + '/books/dist/images/book_cover/cover_adult.png';

export interface BookDetailContextType {
  bookId: number;
  categoryName: string;
  bookApiUrl: string;
  apiServerUrl: string;
  isVerifiedAdult: boolean;
  adultBookCover: string;
  featureGuard: Record<string, boolean>;
}

export const BookDetailContext = createContext<BookDetailContextType>({
  bookId: -1,
  categoryName: '',
  bookApiUrl: 'https://book-api.ridibooks.com',
  apiServerUrl: 'https://api.ridibooks.com',
  isVerifiedAdult: false,
  adultBookCover: ADULT_COVER_URL,
  featureGuard: {},
});



// WEBPACK FOOTER //
// ./pages/bookDetail/components/BookDetailContext.ts